module.exports = __webpack_public_path__ + "b2cc6078cb78180b68e06ee607ca0013.pdf";